import { render, staticRenderFns } from "./ShofurInsurance.vue?vue&type=template&id=aab4ffec&scoped=true"
var script = {}
import style0 from "./ShofurInsurance.vue?vue&type=style&index=0&id=aab4ffec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab4ffec",
  null
  
)

export default component.exports